import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: #3e3d3f;
  background: transparent;
  transition: all 0.5s;
  opacity: ${(props) => (props.isSelected || props.canExpand ? 1 : 0.5)};
  @media (max-width: 1400px) {
    width: 80px;
    font-size: 12px;
  }
`;
